import React from "react";
import PropTypes from "prop-types";
import {FaRegularIcon, FaSolidIcon} from "../../components/FontAwesomeIcons";

export function GoogleCalendarListGroupItem({calendar, ...props}) {

    const handleDelete = _ => props.onDelete(calendar.calendar_id);
    const handleSetDefault = _ => props.onSetDefault(calendar.calendar_id);

    const calendarName = calendar ? (calendar.full_data?.summaryOverride || calendar.full_data?.summary || calendar.calendar_id || "Calendario") : "Calendario";


    return (
        <div>
            <div className={"d-flex align-items-center justify-content-between"}>
                <div className={"font-weight-bold"} onClick={calendar.is_default == 1 ? undefined : handleSetDefault}>
                    {calendar.is_default == 1 ? <FaSolidIcon name={"check-circle"} className={"text-success"}/> : <FaRegularIcon name={"circle"} className={"text-muted"}/>}
                    <span className={"ml-2"}>{calendarName}</span>
                </div>
                <button className={"btn btn-link text-muted small p-0 mt-2"} onClick={handleDelete}>
                    <FaSolidIcon name={"trash"}/>
                </button>
            </div>
            {
                (calendar.is_default == 1) &&
                <span className={"badge badge-success mt-2"}>Le prenotazioni si sincronizzano qui</span>
            }
        </div>

    );
}

GoogleCalendarListGroupItem.propTypes = {
    calendar: PropTypes.shape({
        calendar_id: PropTypes.any,
        full_data: PropTypes.object,
        is_default: PropTypes.number,
    }),
    onDelete: PropTypes.func,
    onSetDefault: PropTypes.func,
}
